import { render, staticRenderFns } from "./PanelAccountSettingsOperatorPayments.vue?vue&type=template&id=71edd4a9&scoped=true&"
import script from "./PanelAccountSettingsOperatorPayments.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsOperatorPayments.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsOperatorPayments.vue?vue&type=style&index=0&id=71edd4a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edd4a9",
  null
  
)

export default component.exports